export default {
  allHarvestTypes: (state) => state.harvestTypes,
  harvestTypesLoading: (state) => state.loading
}
